/**
 * Mock container product listings.
 * NOTE: Images, availability and specifications are demo data and must be
 * replaced or populated through the future backend.
 */

const commonSpecs = (size) => [
    { label: "External Size", value: size },
    { label: "Material", value: "Corten Steel" },
    { label: "Doors", value: "Standard cargo doors" },
    { label: "Flooring", value: "Marine plywood" },
];

const commonImages = (main) => [
    { id: "img-1", url: main, alt: "Container primary view", sortOrder: 1 },
    {
        id: "img-2",
        url: "https://images.pexels.com/photos/13427763/pexels-photo-13427763.jpeg?auto=compress&cs=tinysrgb&w=1200",
        alt: "Container door detail",
        sortOrder: 2,
    },
    {
        id: "img-3",
        url: "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&w=1200&q=80",
        alt: "Container yard context",
        sortOrder: 3,
    },
];

export const mockProducts = [
    {
        id: "prd-01",
        referenceNumber: "CS-N20-STG-001",
        name: "20ft New Storage Container",
        slug: "20ft-new-storage-container",
        categoryId: "cat-new",
        categoryName: "New Containers",
        containerType: "Storage Container",
        size: "20ft × 8ft",
        condition: "new",
        availability: "available",
        shortDescription:
            "A clean, brand-new 20ft steel container ideal for secure on-site storage of equipment, tools and inventory.",
        description:
            "Our 20ft new storage container is supplied unmodified and ready for site placement. Its clean exterior makes it an excellent base for future branding, painting or modification. Suitable for construction sites, industrial yards, warehouses and equipment stores across Singapore.",
        features: [
            "Brand new corten steel construction",
            "Full cargo doors with locking bars",
            "Weather-resistant seal",
            "Marine plywood flooring",
            "Vermin-resistant design",
        ],
        specifications: commonSpecs("20ft × 8ft"),
        applications: ["Construction Sites", "Equipment Storage", "Warehousing and Storage", "Industrial Facilities"],
        customisationOptions: ["Personnel door", "Windows", "Internal lining", "External repainting"],
        images: commonImages(
            "https://images.unsplash.com/photo-1706499856012-14f062c72b49?auto=format&fit=crop&w=1200&q=80",
        ),
        featuredImage:
            "https://images.unsplash.com/photo-1706499856012-14f062c72b49?auto=format&fit=crop&w=1200&q=80",
        featured: true,
        newListing: true,
        status: "published",
        seo: {
            title: "20ft New Storage Container Singapore | Container Specialist",
            description:
                "Brand new 20ft steel storage container for sale in Singapore. Weather-resistant, secure and ready for site placement.",
            keywords: ["20ft new container Singapore", "new storage container", "steel container 20ft"],
            slug: "20ft-new-storage-container",
        },
        createdAt: "2024-11-02T00:00:00Z",
        updatedAt: "2024-12-05T00:00:00Z",
    },
    {
        id: "prd-02",
        referenceNumber: "CS-N40-STG-002",
        name: "40ft New Storage Container",
        slug: "40ft-new-storage-container",
        categoryId: "cat-new",
        categoryName: "New Containers",
        containerType: "Storage Container",
        size: "40ft × 8ft",
        condition: "new",
        availability: "available",
        shortDescription:
            "A brand-new 40ft container offering generous storage capacity for large-scale site operations and inventory.",
        description:
            "The 40ft new storage container doubles the internal footprint of a standard 20ft. Ideal for projects requiring greater storage volume, larger workspaces or as a foundation for extensive customisation.",
        features: [
            "40ft clean corten steel body",
            "Twin cargo doors with locking mechanism",
            "Marine plywood flooring",
            "Rain-tight seal",
            "Structural forklift pockets",
        ],
        specifications: commonSpecs("40ft × 8ft"),
        applications: ["Warehousing and Storage", "Logistics Operations", "Industrial Facilities", "Special Projects"],
        customisationOptions: ["Personnel doors", "Roller shutter door", "Insulation", "Lighting"],
        images: commonImages(
            "https://images.pexels.com/photos/32865462/pexels-photo-32865462.jpeg?auto=compress&cs=tinysrgb&w=1200",
        ),
        featuredImage:
            "https://images.pexels.com/photos/32865462/pexels-photo-32865462.jpeg?auto=compress&cs=tinysrgb&w=1200",
        featured: true,
        newListing: true,
        status: "published",
        seo: {
            title: "40ft New Storage Container Singapore | Container Specialist",
            description: "Brand new 40ft storage container for sale in Singapore.",
            keywords: ["40ft new container Singapore", "new storage container 40ft"],
            slug: "40ft-new-storage-container",
        },
        createdAt: "2024-10-20T00:00:00Z",
        updatedAt: "2024-12-04T00:00:00Z",
    },
    {
        id: "prd-03",
        referenceNumber: "CS-U20-STG-003",
        name: "20ft Used Storage Container",
        slug: "20ft-used-storage-container",
        categoryId: "cat-used",
        categoryName: "Used Containers",
        containerType: "Storage Container",
        size: "20ft × 8ft",
        condition: "used",
        availability: "available",
        shortDescription:
            "A cost-effective 20ft used container in reasonable condition, ready for site storage or modification.",
        description:
            "A practical, budget-friendly 20ft container. Exact appearance and condition vary between individual units. Best suited for storage, site materials and modification projects where a fresh new exterior is not required.",
        features: [
            "Structurally sound corten steel body",
            "Sealed doors with functional locking bars",
            "Weather-tight interior",
            "Repairs completed where required",
        ],
        specifications: commonSpecs("20ft × 8ft"),
        applications: ["Construction Sites", "Equipment Storage", "Special Projects"],
        customisationOptions: ["Repainting", "Windows", "Personnel door"],
        images: commonImages(
            "https://images.pexels.com/photos/13427763/pexels-photo-13427763.jpeg?auto=compress&cs=tinysrgb&w=1200",
        ),
        featuredImage:
            "https://images.pexels.com/photos/13427763/pexels-photo-13427763.jpeg?auto=compress&cs=tinysrgb&w=1200",
        featured: true,
        newListing: false,
        status: "published",
        seo: {
            title: "20ft Used Storage Container Singapore | Container Specialist",
            description: "Affordable 20ft used steel storage container for sale in Singapore.",
            keywords: ["20ft used container", "used storage container Singapore"],
            slug: "20ft-used-storage-container",
        },
        createdAt: "2024-09-15T00:00:00Z",
        updatedAt: "2024-11-30T00:00:00Z",
    },
    {
        id: "prd-04",
        referenceNumber: "CS-U40-CGO-004",
        name: "40ft Used Cargo-Worthy Container",
        slug: "40ft-used-cargo-worthy-container",
        categoryId: "cat-used",
        categoryName: "Used Containers",
        containerType: "Cargo-Worthy Container",
        size: "40ft × 8ft",
        condition: "used",
        availability: "limited",
        shortDescription:
            "A 40ft used container in cargo-worthy condition, suitable for freight movement and logistics use.",
        description:
            "Cargo-worthy 40ft used unit supplied subject to individual inspection. Suitable for shipping and freight operations. Availability changes over time — contact us to confirm.",
        features: [
            "Cargo-worthy assessment on selected units",
            "Wind and watertight construction",
            "Standard cargo doors",
            "Structural integrity checked",
        ],
        specifications: commonSpecs("40ft × 8ft"),
        applications: ["Logistics Operations", "Warehousing and Storage", "Special Projects"],
        customisationOptions: ["Repainting"],
        images: commonImages(
            "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&w=1200&q=80",
        ),
        featuredImage:
            "https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?auto=format&fit=crop&w=1200&q=80",
        featured: false,
        newListing: false,
        status: "published",
        seo: {
            title: "40ft Cargo-Worthy Used Container Singapore | Container Specialist",
            description: "40ft cargo-worthy used shipping container for logistics and freight in Singapore.",
            keywords: ["cargo worthy container Singapore", "40ft used shipping container"],
            slug: "40ft-used-cargo-worthy-container",
        },
        createdAt: "2024-08-28T00:00:00Z",
        updatedAt: "2024-11-22T00:00:00Z",
    },
    {
        id: "prd-05",
        referenceNumber: "CS-C20-OFF-005",
        name: "20ft Container Office",
        slug: "20ft-container-office",
        categoryId: "cat-custom",
        categoryName: "Customised Containers",
        containerType: "Office Container",
        size: "20ft × 8ft",
        condition: "custom-build",
        availability: "made-to-order",
        shortDescription:
            "A 20ft container converted into a practical portable office with doors, windows and electrical fittings.",
        description:
            "Portable 20ft office container fitted with a personnel door, windows, internal lining, lighting, power points and provision for air-conditioning. Layout can be adjusted according to your worksite requirements.",
        features: [
            "Personnel door with lockset",
            "Sliding windows",
            "Internal wall and ceiling lining",
            "Lighting and power points",
            "AC provision (unit optional)",
        ],
        specifications: [
            ...commonSpecs("20ft × 8ft"),
            { label: "Electrical", value: "Configurable" },
            { label: "Air-Conditioning", value: "Provision ready" },
        ],
        applications: ["Temporary Offices", "Construction Sites", "Industrial Facilities", "Events and Temporary Spaces"],
        customisationOptions: [
            "Additional windows",
            "Partition walls",
            "Air-conditioning unit",
            "External signage",
            "Custom paintwork",
        ],
        images: commonImages(
            "https://images.unsplash.com/photo-1655720845450-b3f2df8b562b?auto=format&fit=crop&w=1200&q=80",
        ),
        featuredImage:
            "https://images.unsplash.com/photo-1655720845450-b3f2df8b562b?auto=format&fit=crop&w=1200&q=80",
        featured: true,
        newListing: true,
        status: "published",
        seo: {
            title: "20ft Container Office Singapore | Container Specialist",
            description: "20ft container office with doors, windows, lighting and AC provision. Made-to-order in Singapore.",
            keywords: ["container office Singapore", "20ft container office", "site office container"],
            slug: "20ft-container-office",
        },
        createdAt: "2024-11-10T00:00:00Z",
        updatedAt: "2024-12-06T00:00:00Z",
    },
    {
        id: "prd-06",
        referenceNumber: "CS-C40-OFF-006",
        name: "40ft Container Office",
        slug: "40ft-container-office",
        categoryId: "cat-custom",
        categoryName: "Customised Containers",
        containerType: "Office Container",
        size: "40ft × 8ft",
        condition: "custom-build",
        availability: "made-to-order",
        shortDescription:
            "A spacious 40ft office container ideal for site management, meeting rooms and multi-desk workspaces.",
        description:
            "40ft container office configured to your operational needs. Suitable for site management offices, briefing rooms and multi-workstation setups. Interior layout, partitions and finishes are agreed prior to fabrication.",
        features: [
            "Multiple personnel doors",
            "Insulated walls and ceiling",
            "Lighting, power and network points",
            "AC provision",
            "Flexible partitions",
        ],
        specifications: [
            ...commonSpecs("40ft × 8ft"),
            { label: "Partitions", value: "Configurable" },
            { label: "Insulation", value: "Available" },
        ],
        applications: ["Temporary Offices", "Construction Sites", "Industrial Facilities", "Special Projects"],
        customisationOptions: ["Split rooms", "Toilet cubicle", "Pantry area", "Storage room", "Custom branding"],
        images: commonImages(
            "https://images.pexels.com/photos/21533662/pexels-photo-21533662.jpeg?auto=compress&cs=tinysrgb&w=1200",
        ),
        featuredImage:
            "https://images.pexels.com/photos/21533662/pexels-photo-21533662.jpeg?auto=compress&cs=tinysrgb&w=1200",
        featured: true,
        newListing: false,
        status: "published",
        seo: {
            title: "40ft Container Office Singapore | Container Specialist",
            description: "40ft container office for site management and multi-workstation setups. Made-to-order in Singapore.",
            keywords: ["40ft container office", "site office 40ft", "container office Singapore"],
            slug: "40ft-container-office",
        },
        createdAt: "2024-10-05T00:00:00Z",
        updatedAt: "2024-12-01T00:00:00Z",
    },
    {
        id: "prd-07",
        referenceNumber: "CS-C20-GRD-007",
        name: "20ft Guard House Container",
        slug: "20ft-guard-house-container",
        categoryId: "cat-custom",
        categoryName: "Customised Containers",
        containerType: "Guard House",
        size: "20ft × 8ft",
        condition: "custom-build",
        availability: "made-to-order",
        shortDescription:
            "A compact 20ft guard house container designed for site security posts and access-control points.",
        description:
            "Compact guard house unit with visibility windows, a lockable door and provision for lighting and power. Ideal for construction sites, industrial yards and access-control points.",
        features: [
            "360° visibility windows configurable",
            "Lockable personnel door",
            "Lighting and power provision",
            "Internal desk-height ledge (optional)",
        ],
        specifications: [
            ...commonSpecs("20ft × 8ft"),
            { label: "Window Layout", value: "Configurable" },
        ],
        applications: ["Security Posts", "Construction Sites", "Industrial Facilities"],
        customisationOptions: ["Air-conditioning", "Reinforced door", "CCTV mount points", "Signage"],
        images: commonImages(
            "https://images.pexels.com/photos/2380795/pexels-photo-2380795.jpeg?auto=compress&cs=tinysrgb&w=1200",
        ),
        featuredImage:
            "https://images.pexels.com/photos/2380795/pexels-photo-2380795.jpeg?auto=compress&cs=tinysrgb&w=1200",
        featured: false,
        newListing: true,
        status: "published",
        seo: {
            title: "20ft Guard House Container Singapore | Container Specialist",
            description: "Compact 20ft guard house container for site security and access control in Singapore.",
            keywords: ["guard house container Singapore", "security post container"],
            slug: "20ft-guard-house-container",
        },
        createdAt: "2024-11-18T00:00:00Z",
        updatedAt: "2024-12-05T00:00:00Z",
    },
    {
        id: "prd-08",
        referenceNumber: "CS-C20-SAN-008",
        name: "20ft Sanitary Toilet Container",
        slug: "20ft-sanitary-toilet-container",
        categoryId: "cat-custom",
        categoryName: "Customised Containers",
        containerType: "Sanitary or Toilet Container",
        size: "20ft × 8ft",
        condition: "custom-build",
        availability: "made-to-order",
        shortDescription:
            "A 20ft toilet and sanitary container fitted with plumbing, ventilation and fixtures for site facilities.",
        description:
            "Sanitary container fitted with cubicles, plumbing, ventilation and lighting. Configurable for male/female facilities and shower cubicles where required.",
        features: [
            "Plumbing and fixtures fitted",
            "Ventilation and lighting",
            "Non-slip flooring",
            "Male / Female / Combined layouts",
        ],
        specifications: [
            ...commonSpecs("20ft × 8ft"),
            { label: "Plumbing", value: "Fitted" },
            { label: "Ventilation", value: "Included" },
        ],
        applications: ["Sanitary Facilities", "Workers' Facilities", "Construction Sites", "Events and Temporary Spaces"],
        customisationOptions: ["Shower cubicles", "Urinal wall", "Hand-wash counters", "Water heater"],
        images: commonImages(
            "https://images.pexels.com/photos/8961026/pexels-photo-8961026.jpeg?auto=compress&cs=tinysrgb&w=1200",
        ),
        featuredImage:
            "https://images.pexels.com/photos/8961026/pexels-photo-8961026.jpeg?auto=compress&cs=tinysrgb&w=1200",
        featured: true,
        newListing: false,
        status: "published",
        seo: {
            title: "20ft Toilet Container Singapore | Container Specialist",
            description: "Sanitary and toilet container units for construction sites, events and industrial facilities in Singapore.",
            keywords: ["toilet container Singapore", "sanitary container", "portable toilet unit"],
            slug: "20ft-sanitary-toilet-container",
        },
        createdAt: "2024-09-28T00:00:00Z",
        updatedAt: "2024-11-27T00:00:00Z",
    },
    {
        id: "prd-09",
        referenceNumber: "CS-C40-WRK-009",
        name: "40ft Workers' Quarters Container",
        slug: "40ft-workers-quarters-container",
        categoryId: "cat-custom",
        categoryName: "Customised Containers",
        containerType: "Workers' Quarters",
        size: "40ft × 8ft",
        condition: "custom-build",
        availability: "made-to-order",
        shortDescription:
            "A 40ft container configured as workers' quarters with insulation, ventilation and internal partitions.",
        description:
            "Purpose-built accommodation unit with insulated walls, ventilation, lighting, power and configurable bunk / partition layouts. Suitable for site accommodation subject to project requirements.",
        features: [
            "Insulated walls and ceiling",
            "Ventilation and lighting",
            "Configurable bunk layouts",
            "Power outlets throughout",
        ],
        specifications: [
            ...commonSpecs("40ft × 8ft"),
            { label: "Insulation", value: "Included" },
            { label: "Bunk Layout", value: "Configurable" },
        ],
        applications: ["Workers' Facilities", "Construction Sites", "Industrial Facilities"],
        customisationOptions: ["Air-conditioning", "Locker installation", "En-suite toilet", "Kitchen area"],
        images: commonImages(
            "https://images.pexels.com/photos/8961014/pexels-photo-8961014.jpeg?auto=compress&cs=tinysrgb&w=1200",
        ),
        featuredImage:
            "https://images.pexels.com/photos/8961014/pexels-photo-8961014.jpeg?auto=compress&cs=tinysrgb&w=1200",
        featured: false,
        newListing: false,
        status: "published",
        seo: {
            title: "40ft Workers' Quarters Container Singapore | Container Specialist",
            description: "40ft workers' quarters container with insulation, ventilation and configurable bunk layouts.",
            keywords: ["workers quarters container", "worker accommodation Singapore"],
            slug: "40ft-workers-quarters-container",
        },
        createdAt: "2024-10-14T00:00:00Z",
        updatedAt: "2024-12-02T00:00:00Z",
    },
    {
        id: "prd-10",
        referenceNumber: "CS-U20-RFR-010",
        name: "20ft Refrigerated Container",
        slug: "20ft-refrigerated-container",
        categoryId: "cat-used",
        categoryName: "Used Containers",
        containerType: "Refrigerated Container",
        size: "20ft × 8ft",
        condition: "refurbished",
        availability: "enquire",
        shortDescription:
            "A 20ft insulated reefer container for cold storage applications. Availability and specifications on request.",
        description:
            "Insulated refrigerated (reefer) container suitable for cold storage. Temperature range and power requirements should be confirmed prior to purchase.",
        features: [
            "Insulated container body",
            "Refrigeration unit fitted",
            "Configurable temperature range",
            "3-phase power requirement",
        ],
        specifications: [
            ...commonSpecs("20ft × 8ft"),
            { label: "Insulation", value: "Included" },
            { label: "Power", value: "3-phase" },
        ],
        applications: ["Warehousing and Storage", "Industrial Facilities", "Special Projects"],
        customisationOptions: ["Shelving", "Data logger", "Access lighting"],
        images: commonImages(
            "https://images.unsplash.com/photo-1580674285054-bed31e145f59?auto=format&fit=crop&w=1200&q=80",
        ),
        featuredImage:
            "https://images.unsplash.com/photo-1580674285054-bed31e145f59?auto=format&fit=crop&w=1200&q=80",
        featured: false,
        newListing: false,
        status: "published",
        seo: {
            title: "20ft Reefer Refrigerated Container Singapore | Container Specialist",
            description: "20ft refrigerated reefer container for cold storage applications in Singapore.",
            keywords: ["reefer container Singapore", "refrigerated container", "cold storage container"],
            slug: "20ft-refrigerated-container",
        },
        createdAt: "2024-09-05T00:00:00Z",
        updatedAt: "2024-11-19T00:00:00Z",
    },
    {
        id: "prd-11",
        referenceNumber: "CS-C40-SIT-011",
        name: "Customised Site Office Container",
        slug: "customised-site-office-container",
        categoryId: "cat-custom",
        categoryName: "Customised Containers",
        containerType: "Customised Container",
        size: "40ft × 10ft",
        condition: "custom-build",
        availability: "made-to-order",
        shortDescription:
            "A 40ft × 10ft wide-body container configured as a multi-room site office with meeting space and pantry.",
        description:
            "Wider 10ft configuration for large project offices requiring meeting rooms, workstation zones and a pantry area. Interior layout, finishes and services are agreed with you before fabrication.",
        features: [
            "Wide 10ft footprint",
            "Multi-room layout",
            "Insulated walls and ceiling",
            "Lighting, power and network provision",
            "AC provision",
        ],
        specifications: [
            { label: "External Size", value: "40ft × 10ft" },
            { label: "Layout", value: "Multi-room configurable" },
            { label: "Insulation", value: "Included" },
            { label: "Services", value: "Configurable" },
        ],
        applications: ["Temporary Offices", "Construction Sites", "Special Projects", "Industrial Facilities"],
        customisationOptions: [
            "Meeting room partitions",
            "Executive office",
            "Server / equipment room",
            "Toilet cubicle",
            "External branding",
        ],
        images: commonImages(
            "https://images.pexels.com/photos/21533662/pexels-photo-21533662.jpeg?auto=compress&cs=tinysrgb&w=1200",
        ),
        featuredImage:
            "https://images.pexels.com/photos/21533662/pexels-photo-21533662.jpeg?auto=compress&cs=tinysrgb&w=1200",
        featured: true,
        newListing: true,
        status: "published",
        seo: {
            title: "Customised 40ft x 10ft Site Office Container Singapore",
            description: "Customised 40ft × 10ft wide-body site office container with multi-room layout and services.",
            keywords: ["customised site office container", "40ft x 10ft container Singapore"],
            slug: "customised-site-office-container",
        },
        createdAt: "2024-11-25T00:00:00Z",
        updatedAt: "2024-12-08T00:00:00Z",
    },
    {
        id: "prd-12",
        referenceNumber: "CS-C20-COM-012",
        name: "Customised Commercial Container Unit",
        slug: "customised-commercial-container-unit",
        categoryId: "cat-custom",
        categoryName: "Customised Containers",
        containerType: "Customised Container",
        size: "20ft × 10ft",
        condition: "custom-build",
        availability: "made-to-order",
        shortDescription:
            "A 20ft × 10ft container converted into a purpose-built commercial or retail unit with a custom fit-out.",
        description:
            "Wider 20ft × 10ft container configured for retail or commercial use — service counters, display shelving, lighting and external branding. Feasibility depends on your specific concept and location.",
        features: [
            "Wide 10ft footprint",
            "Custom service counter",
            "Retail-grade finishes",
            "External signage panels",
            "Lighting and power",
        ],
        specifications: [
            { label: "External Size", value: "20ft × 10ft" },
            { label: "Configuration", value: "Commercial fit-out" },
            { label: "Services", value: "Custom" },
            { label: "Finishes", value: "Retail-grade" },
        ],
        applications: ["Retail or Commercial Concepts", "Events and Temporary Spaces", "Special Projects"],
        customisationOptions: ["Serving hatch", "Fold-out counter", "Awning", "Cladding", "Full brand paintwork"],
        images: commonImages(
            "https://images.unsplash.com/photo-1655720845450-b3f2df8b562b?auto=format&fit=crop&w=1200&q=80",
        ),
        featuredImage:
            "https://images.unsplash.com/photo-1655720845450-b3f2df8b562b?auto=format&fit=crop&w=1200&q=80",
        featured: false,
        newListing: true,
        status: "published",
        seo: {
            title: "Customised Commercial Container Unit Singapore | Container Specialist",
            description: "A 20ft × 10ft commercial container fit-out for retail concepts and pop-up spaces in Singapore.",
            keywords: ["commercial container Singapore", "retail container", "pop-up container"],
            slug: "customised-commercial-container-unit",
        },
        createdAt: "2024-12-01T00:00:00Z",
        updatedAt: "2024-12-08T00:00:00Z",
    },
];
